import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    renderingComps: (count: number) => string;
    description: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Message to show when compositions are rendering */
            renderingComps: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "UIBlock.renderingComps?c=12b3g2fyz8qcn", defaultMessage: "{count, plural, one {Rendering {count} composition.} other {Rendering {count} compositions.}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description to show when compositions are rendering */
            description: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UIBlock.description?c=2osm6ks76hekl", defaultMessage: "Panel is paused during rendering. Monitor or cancel in the Render Queue panel." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
